import { FC, ReactNode } from 'react';
import ReactDOM from 'react-dom';


const root = document.getElementById('root');

export type PortalProps = {
    children: ReactNode;
}

export const Portal: FC<PortalProps> = ({ children }) =>
    root && ReactDOM.createPortal(children, root);
